export default __webpack_public_path__ + "images/ffe211258609253cbce7192f4b354673.svg";